import * as React from "react";
const SvgFiRrMound = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mound_svg__a)">
      <path
        fill="#062147"
        d="m23.628 19.296-3.738-7.398A8.8 8.8 0 0 0 12 7.045a8.8 8.8 0 0 0-7.89 4.853l-3.734 7.39a3.23 3.23 0 0 0 .093 3.19 3.21 3.21 0 0 0 2.769 1.567h17.524a3.21 3.21 0 0 0 2.769-1.567 3.22 3.22 0 0 0 .097-3.182m-1.81 2.15a1.21 1.21 0 0 1-1.056.599H3.238c-.442 0-.827-.218-1.056-.6a1.23 1.23 0 0 1-.034-1.23l.009-.017L5.895 12.8C7.083 10.448 9.365 9.045 12 9.045s4.917 1.404 6.105 3.755l3.747 7.415c.21.397.198.846-.034 1.23"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mound_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMound;
